import gql from "graphql-tag";
import {apolloClient} from "@/plugins/apollo";

export function getTrainingQueryBody() {
    return `
                        id
                        updatedAt
                        createdAt
                        accessForAll
                        accessForParticipants
                        participant1CustomName
                        participant2CustomName
                        participant3CustomName
                        participant4CustomName
                        participant5CustomName
                        participant6CustomName
                        participant7CustomName
                        participant8CustomName
                        equipmentType
                        ergType
                        boatType
                        trainingProfile {
                            name
                            checksQty
                        }
                        owner {
                            id
                            username
                         }
                        participant1 {
                            id
                            username
                        }
                        participant2 {
                            id
                            username
                        }
                        participant3 {
                            id
                            username
                        }
                        participant4 {
                            id
                            username
                        }
                        participant5 {
                            id
                            username
                        }
                        participant6 {
                            id
                            username
                        }
                        participant7 {
                            id
                            username
                        }
                        participant8 {
                            id
                            username
                        }
                        videos {
                            createdAt
                            id
                            updatedAt
                            videoProcessing {
                                transcodedVideo {
                                    id
                                }
                                transcodedVideoPoster {
                                    id
                                }
                            }
                            videoProcessingResult {
                                errors
                                finishedAt
                                updatedAt
                                id
                                footageQuality
                                analysisWarningsInfo

                                reportPdf1 {
                                    id
                                }
                                reportInstaVideo1 {
                                    id
                                }
                                reportPcVideo1 {
                                    id
                                }
                                reportPcVideo1Poster {
                                    id
                                }
                                strokesWMismatchesNums1
                                mismatchesPerStrokeQty1
                                strokes1
                                avgScore1
                                reportPcVideo1FramesSchema

                                reportPdf2 {
                                    id
                                }
                                reportInstaVideo2 {
                                    id
                                }
                                reportPcVideo2 {
                                    id
                                }
                                reportPcVideo2Poster {
                                    id
                                }
                                strokesWMismatchesNums2
                                mismatchesPerStrokeQty2
                                strokes2
                                avgScore2
                                reportPcVideo2FramesSchema


                                reportPdf3 {
                                    id
                                }
                                reportInstaVideo3 {
                                    id
                                }
                                reportPcVideo3 {
                                    id
                                }
                                reportPcVideo3Poster {
                                    id
                                }
                                strokesWMismatchesNums3
                                mismatchesPerStrokeQty3
                                strokes3
                                avgScore3
                                reportPcVideo3FramesSchema


                                reportPdf4 {
                                    id
                                }
                                reportInstaVideo4 {
                                    id
                                }
                                reportPcVideo4 {
                                    id
                                }
                                reportPcVideo4Poster {
                                    id
                                }
                                strokesWMismatchesNums4
                                mismatchesPerStrokeQty4
                                strokes4
                                avgScore4
                                reportPcVideo4FramesSchema


                                reportPdf5 {
                                    id
                                }
                                reportInstaVideo5 {
                                    id
                                }
                                reportPcVideo5 {
                                    id
                                }
                                reportPcVideo5Poster {
                                    id
                                }
                                strokesWMismatchesNums5
                                mismatchesPerStrokeQty5
                                strokes5
                                avgScore5
                                reportPcVideo5FramesSchema


                                reportPdf6 {
                                    id
                                }
                                reportInstaVideo6 {
                                    id
                                }
                                reportPcVideo6 {
                                    id
                                }
                                reportPcVideo6Poster {
                                    id
                                }
                                strokesWMismatchesNums6
                                mismatchesPerStrokeQty6
                                strokes6
                                avgScore6
                                reportPcVideo6FramesSchema


                                reportPdf7 {
                                    id
                                }
                                reportInstaVideo7 {
                                    id
                                }
                                reportPcVideo7 {
                                    id
                                }
                                reportPcVideo7Poster {
                                    id
                                }
                                strokesWMismatchesNums7
                                mismatchesPerStrokeQty7
                                strokes7
                                avgScore7
                                reportPcVideo7FramesSchema


                                reportPdf8 {
                                    id
                                }
                                reportInstaVideo8 {
                                    id
                                }
                                reportPcVideo8 {
                                    id
                                }
                                reportPcVideo8Poster {
                                    id
                                }
                                strokesWMismatchesNums8
                                mismatchesPerStrokeQty8
                                strokes8
                                avgScore8
                                reportPcVideo8FramesSchema

                                reportSrcVideo {
                                    id
                                }
                                reportSrcVideoPoster {
                                    id
                                }

                                avgScore
                                strokesWMismatchesNums
                                mismatchesPerStrokeQty
                                checksPerStrokeQty
                                reportSrcVideoFramesSchema
                                spmRounded
                                strokesQty
                                reportSrcVideoDurationS
                                criticalErrorFlag
                                errors
                                progress
                            }
                        }
                        comments {
                            owner {
                                username
                                id
                            }
                            id
                            text
                            createdAt
                            updatedAt
                        }
                        accessForUsers {
                            id
                            username
                        }
                        inMyTrainingsFlag
                        forDelete
    `;
}

/**
 * @param {string} search JSON string
 * @param {number} firstN
 * @returns {Promise<[{id: number, name: string, description: string, isGlobal: boolean}]>}
 */
export async function trainingProfileSearch(search = '', firstN= 99) {
    let query = gql`
                    {
                        trainingProfileSearch (searchString: ${JSON.stringify(search)}, firstN: ${firstN})  {
                            id
                            name
                            description
                            isGlobal
                        }
                    }
                `

    let qRes = await apolloClient.query({query})
    // noinspection UnnecessaryLocalVariableJS
    return qRes.data['trainingProfileSearch']
}

let settingsData;
export async function settings() {
    if (!settingsData) {
        let query = gql`{ settings {
            freeTierName
            freeTierSubtitle
            freeTierButton
            freeTierDescription
        } }`
        let qRes = await apolloClient.query({query})
        settingsData = qRes.data['settings'];
    }
    return settingsData;
}